import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { LP_UI_CONFIG } from '../core/tokens';
import { StorageService } from '../services/storage.service';
import { AlertStatistics } from '../models/classes/alert';

@Injectable({ providedIn: 'root' })
export class AlertStatisticsApi {
  private readonly cfg = inject(LP_UI_CONFIG);
  private http = inject(HttpClient);
  private storage = inject(StorageService);

  private get headers() {
    return {
      Authorization: 'Bearer ' + this.storage.token(),
    };
  }

  /**
   * Fetch alert statistics from the API
   * @returns Promise with alert statistics
   */
  async getAlertStatistics(): Promise<AlertStatistics> {
    return firstValueFrom(
      this.http.get<AlertStatistics>(`${this.cfg.host}api/alert_stats/`, {
        headers: this.headers,
      })
    );
  }
}
